import React from 'react';
import { Mutation } from 'react-apollo';
import { Modal, Button } from '../../../../components';
import accountContactDeleteMutation from './graphql/mutation/accountContactDelete';

class ContactDelete extends React.Component {
	render() {
		return (
			<Mutation
				mutation={accountContactDeleteMutation}
				variables={{
					_id: this.props.contactId,
				}}
				update={(cache, { data }) => {
					if (data.accountContactDelete.succeed) {
						this.props.onHide();
					}
				}}
				onError={error => {
					const textError =
						error.graphQLErrors && error.graphQLErrors.length > 0
							? error.graphQLErrors[0].message
							: error.message;

					alert(textError);
				}}
				refetchQueries={() => ['AccountContactList']}
			>
				{(accountContactDelete, { loading, error }) => {
					return (
						<Modal
							width={640}
							title={this.props.title}
							closable={false}
							visible={this.props.visible}
							onCancel={this.props.onHide}
							footer={[
								<Button key="back" onClick={this.props.onHide}>
									ปิด
								</Button>,
								<Button
									key="submit"
									type="primary"
									onClick={() => accountContactDelete()}
									disabled={loading}
									loading={loading}
								>
									ยืนยัน
								</Button>,
							]}
						>
							กด "ยืนยัน" เพื่อทำการลบรายชื่อผู้ติดต่อ
						</Modal>
					);
				}}
			</Mutation>
		);
	}
}

export default ContactDelete;
